module.exports = __webpack_public_path__ + "img/kachel-VERLETZUNGEN_conzentrat.fe8855d3.png";